import { Flex, Image } from "@chakra-ui/react";
import React from "react";
import BodyText from "../../../components/typography/Body";
import colors from "../../../utils/colors";

const PatientAppointmentCard = ({ img, title, value }) => {
  return (
    <Flex
      boxShadow={`1px 4px 15px 0px rgba(48, 48, 48, 0.12)`}
      border={`1px solid rgba(241, 241, 241, 1)`}
      borderRadius={"8px"}
      padding={"20px"}
      gap={"16px"}
      direction={"column"}
      backgroundColor={"white"}
      width={"180px"}
      //   height={"151px"}
    >
      <Image src={img} boxSize={"40px"} />
      <BodyText fontSize="12px" size="xs" color={colors.secondary}>
        {title}
      </BodyText>
      <BodyText
        fontSize="15px"
        fontWeight={600}
        size="s"
        color={colors.dark}
        noOfLines={1}
      >
        {value}
      </BodyText>
    </Flex>
  );
};

export default PatientAppointmentCard;
